<template>
    <a :href="mentor.permalink" class="mentor-card">
        <div class="mentor-card__img-wrap">
            <template v-if="mentor.avatar_medium_url">
                <img :src="mentor.avatar_medium_url" :alt="'Mentor avatar: ' + mentor.title" class="mentor-card__img" />
            </template>
        </div>
        <div class="mentor-card__body">
            <h3 class="mentor-card__title">{{ mentor.title }}</h3>
            <div class="mentor-card__meta">
                <svg height="20" width="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="m9.69 18.933.003.001C9.89 19.02 10 19 10 19s.11.02.308-.066l.002-.001.006-.003.018-.008a5.741 5.741 0 0 0 .281-.14c.186-.096.446-.24.757-.433.62-.384 1.445-.966 2.274-1.765C15.302 14.988 17 12.493 17 9A7 7 0 1 0 3 9c0 3.492 1.698 5.988 3.355 7.584a13.731 13.731 0 0 0 2.273 1.765 11.842 11.842 0 0 0 .976.544l.062.029.018.008.006.003ZM10 11.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z" clip-rule="evenodd" />
                </svg>
                <span>{{ mentor.city }}, {{mentor.country}}</span>
            </div>
            <p class="mentor-card__bio">
                <!-- decodeRawText() was used instead of v-html for security reasons. A preventive measure to prevent users from injecting malicious code -->
                {{ $func.decodeRawText(getMentorDescription) }}
            </p>
            <div class="mentor-card__tags">
                <span class="mentor-card__tag" v-for="topic in mentor.topic.nodes">{{ getTermName( topic ) }}</span>
            </div>
        </div>
        <div class="mentor-card__popup-cta-wrap">
            <div class="mentor-card__popup-cta">
            <span>
                {{ readMore }}
            </span>
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M3 10a.75.75 0 0 1 .75-.75h10.638L10.23 5.29a.75.75 0 1 1 1.04-1.08l5.5 5.25a.75.75 0 0 1 0 1.08l-5.5 5.25a.75.75 0 1 1-1.04-1.08l4.158-3.96H3.75A.75.75 0 0 1 3 10Z" clip-rule="evenodd" />
                </svg>
            </div>
        </div>
    </a>
</template>

<script>
import i18n from 'src/i18n';
import Icon from "src/views/common/icon";
import {getTermName} from "../../shared/terms";

export default {
    name: "MentorResultCard",
    methods: {getTermName},
    props: {
        mentor: {
            type: Object,
            required: true
        }
    },
    components: {
        Icon
    },
    computed: {
        readMore() {
            return i18n.global.t( 'common.read_more' );
        },
        currentLocale() {
            let url = new URL( window.location );
            let params = new URLSearchParams(url.search);
            let lang = params.get('lang');

            return lang ? lang : '';
        },
        getMentorDescription() {
            if( this.currentLocale === 'es' ) {
                return this.mentor._excerpt_es_ES;
            }
            else if( this.currentLocale === 'fr' ) {
                return this.mentor._excerpt_fr_FR;
            }

            return this.mentor.excerpt;
        }
    },
}
</script>